import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading
  const [wishlist, setWishlist] = useState([]);
  const [cart, setCart] = useState({ items: [] });

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  const refreshCart = useCallback(async () => {
    try { const { data } = await api.get("/cart"); setCart(data); } catch { setCart({ items: [] }); }
  }, []);

  const refreshWishlist = useCallback(async () => {
    try { const { data } = await api.get("/wishlist"); setWishlist(data.items || []); } catch { setWishlist([]); }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setUser(null); return; }
    refreshMe();
  }, [refreshMe]);

  useEffect(() => {
    if (user && user.user_id) { refreshCart(); refreshWishlist(); }
  }, [user, refreshCart, refreshWishlist]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("sf_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.token) localStorage.setItem("sf_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_e) {
      // ignore — best-effort server-side cookie clear; we clear local state regardless
    }
    localStorage.removeItem("sf_token");
    setUser(null);
    setCart({ items: [] });
    setWishlist([]);
  };

  const value = { user, setUser, login, register, logout, refreshMe, cart, refreshCart, wishlist, refreshWishlist };
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
